import { StoreSlice } from '../Store';

export type ThemeMode = 'light' | 'dark' | 'system';

type ThemeStore = {
  mode: ThemeMode;
};

type ThemeActions = {
  setTheme: (mode: ThemeMode) => void;
};

export type ThemeSlice = ThemeStore & ThemeActions;

export const createThemeSlice: StoreSlice<ThemeSlice> = (set) => ({
  mode: 'system',

  setTheme: (mode) =>
    set((prevState) => {
      prevState.theme.mode = mode;
    }),
});
